export default {
	background: "https://assets.swoogo.com/uploads/full/1420057-616dbcdd37034.jpg",
	links: [
		{
			height: "10.5%",
			href: "/member-speakers",
			label: "Member Speakers",
			left: "2.2%",
			top: "68.5%",
			width: "14.8%",
		},
		{
			height: "10.5%",
			href: "/isf-speakers",
			label: "ISF Speakers",
			left: "82.2%",
			top: "68.5%",
			width: "14.8%",
		},
	],
	name: "sponsor-speakers",
}
